import { Component, Input } from '@angular/core'
import { Page } from '../../shared/interfaces/page.interface'
import { ChangeDetectionStrategy } from '@angular/core'
import { CommonModule } from '@angular/common'
@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class PartnersComponent {
  @Input({ required: true }) partnersContent: Page
}
